import {AutogenLayoutEmptyTable} from "./autogen/AutogenLayoutEmptyTable";
import {ClickEvent, Image, Label, Panel, TableRow, TableRowDisplayEvent, Textbox} from "@mcleod/components";
import {OrderTabView} from "../OrderTabView";
import {CommonTooltips} from "@mcleod/common";
import { StringUtil } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { getDispatchControlValue } from "@mcleod/general";

export class EmptyTable extends AutogenLayoutEmptyTable {

    private _isPrevious: boolean = true;

    get isPrevious(): boolean {
        return this._isPrevious;
    }

    set isPrevious(value: boolean) {
        this._isPrevious = value;
    }

    private tableEmptyMovesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const panelFirstLocation = tableRow.findComponentById("panelFirstLocation") as Panel;
        CommonTooltips.setTooltipContentLayout(
            panelFirstLocation,
            modelRow?.get("first_loc_id"),
            "lme/dispatch/LocationQuickInfo"
        );

        const panelLastLocation = tableRow.findComponentById("panelLastLocation") as Panel;
        CommonTooltips.setTooltipContentLayout(
            panelLastLocation,
            modelRow?.get("last_loc_id"),
            "lme/dispatch/LocationQuickInfo"
        );

        const movementId = tableRow.findComponentById("labelMovementId") as Label;
        movementId.addUnderlineWhenMouseOver();

        if (!this._isPrevious) {
            const textboxArrival = tableRow.findComponentById("textboxEmptyArrival") as Textbox;
            textboxArrival.caption = "Scheduled Arrival";
            const textboxDeparture = tableRow.findComponentById("textboxEmptyDeparture") as Textbox;
            textboxDeparture.caption = "Scheduled Departure";
        }

        const imageEmptyStop = tableRow.findComponentById("imageEmptyStop") as Image;
        imageEmptyStop.name = modelRow.getBoolean("is_locate_move") ? ImageName.locateMove: ImageName.emptyMove;
        imageEmptyStop.tooltip = modelRow.getBoolean("is_locate_move") ? "Locate Move" : "Empty Move";

        this.setupMaxTrailers(tableRow);
    }

    labelMovementIdOnClick(event: ClickEvent) {
        const labelMovementId = event.target as Label;
        const panel = labelMovementId.findParentWithId("panelMovement") as Panel;
        const labelOrderId = panel.findComponentById("labelOrderId") as Label;
        const orderId = labelOrderId && !StringUtil.isEmptyString(labelOrderId.text) ? labelOrderId.text : "none";
        OrderTabView.navigateTo({key: labelMovementId.text, orderId: orderId, newTab: true});
    }

    setupMaxTrailers(tableRow: TableRow) {
        const maxTrailers = getDispatchControlValue("maximum_trailers");
        if (maxTrailers) {
            const trailer = tableRow.findComponentById("textboxTrailerNumber") as Textbox;
            trailer?.setProps({ caption: maxTrailers > 1 ? "Trailers" : "Trailer" });
            const trailer2 = tableRow.findComponentById("textboxTrailer2") as Textbox;
            const trailer3 = tableRow.findComponentById("textboxTrailer3") as Textbox;
            trailer2?.setProps({ visible: maxTrailers > 1 });
            trailer3?.setProps({ visible: maxTrailers > 2 });
        }
    }

}
